import React from 'react';
import { Select } from 'antd';
import { useI18n } from '../i18n/i18n';

const LanguageSwitch = ({ style }) => {
  const { lang, setLang } = useI18n();
  return (
    <Select
      value={lang}
      style={{ width: 120, ...(style || {}) }}
      onChange={setLang}
      options={[
        { value: 'zh', label: '中文' },
        { value: 'en', label: 'English' },
      ]}
    />
  );
};

export default LanguageSwitch;